<template>
  <div>
    <div class="sidebar" :class="{ 'sidebar-expanded': sidebarWidth }"
      @click.self="!sidebarWidth ? changeWidth() : null">
      <!-- logo -->
      <div class="sidebar-item_img">
        <div @click="!sidebarWidth ? changeWidth() : goHome()" class="sidebar_logo">
          <img src="../assets/images/sidebar_logo.png" class="sidebar-logo" alt="" />
        </div>
        <div v-if="sidebarWidth" class="homeFontCn">{{ $t('bar.title') }}</div>
        <img v-if="sidebarWidth" src="../assets/images/fold.png" @click="changeWidth" class="sidebar-fold" alt="" />
      </div>
      <!-- 新对话 -->
      <div class="sidebar-item_new mg-top" :class="{ disabled: isWecomePage }" @click="newChat"
        @mouseenter="isHoveringNewChat = true" @mouseleave="isHoveringNewChat = false">
        <img class="sidebar-item_clear" :src="isHoveringNewChat && !isWecomePage
          ? require('@/assets/images/newChat_hover.png')
          : require('@/assets/images/newChat.png')" />
        <div class="no-rem">{{ $t('bar.newChat') }}</div>
      </div>

      <!-- 新项目 -->
      <div class="sidebar-item_new mg-new" @click="handleReferenceClick" :class="{ 'item_fold': sidebarWidth }"
        @mouseenter="NewChat_clear = true" @mouseleave="NewChat_clear = false">
        <img v-show="!sidebarWidth" class="sidebar-item_clear" :src="NewChat_clear && !isWecomePage
          ? require('@/assets/images/newProject_hover.png')
          : require('@/assets/images/newProject.png')" />
        <div class="no-rem no-left">{{ $t('bar.newProject') }}
          <img v-show="sidebarWidth" class="item_harvest" :src="showHistory
            ? require('@/assets/images/harvest_hover.png')
            : require('@/assets/images/harvest.png')" alt="">
        </div>
        <span v-show="sidebarWidth" class="item_add dropdown-trigger">
          <img class="item_add_img" src="../assets/images/add.png" alt="">
        </span>
      </div>

      <!-- el-dropdown 绑定在整个容器上，但通过事件控制是否触发 -->
      <el-dropdown trigger="click" :disabled="isWecomePage" @command="handleCommand" class="el-dropdown"
        placement="bottom-end" ref="dropdownRef">
        <div class="dropdown-reference-wrapper"> </div>
        <el-dropdown-menu class="dropdown_newProject">
          <template v-for="(item, index) in siderBarList">
            <el-dropdown-item :command="{ code: item.code, title: item.title, index: index }"
              :class="{ 'selected-background': accessType === item.code }" class="dropdown_newProject_item">
              <img class="dropdown_newProject_item_img" :src="handlerImg(item.code)" alt="">
              <div class="dropdown_newProject_item_div">{{ item.title }}项目</div>
            </el-dropdown-item>
            <div v-if="index < siderBarList.length - 1" class="custom-divider"></div>
          </template>
        </el-dropdown-menu>
      </el-dropdown>

      <!-- tpc,tzj历史记录 -->
      <div v-show="sidebarWidth && userInfo" class="sidebar_history_item">
        <div class="sidebar_history" ref="sidebarHistoryScroller">
          <div v-show="showHistory">
            <chatList ref="chatListT" type="t" :sidebar-width="true" @start-new-chat="$emit('start-new-chat')"
              @empty="onCarbonHistoryEmpty" @not-empty="onCarbonHistoryNotEmpty" />
          </div>
          <div class="sidebar_hrje">
          <div class="history-separator"></div>
          <div @click="handlerhistoryhr"  class="sidebar_history_hr">历史对话 <img class="item_harvest" :src="showhistoryhr
            ? require('@/assets/images/harvest_hover.png')
            : require('@/assets/images/harvest.png')" alt=""></div>
          </div>
          <div v-show="showhistoryhr" class="ai-history">
            <chatList ref="chatListAi" type="tz" :sidebar-width="true" @start-new-chat="$emit('start-new-chat')"
              @empty="onAiHistoryEmpty" @not-empty="onAiHistoryNotEmpty" />
          </div>
        </div>
      </div>
      <!-- 用户头像，二级菜单 -->
      <div class="sidebar-item_new sidebar-specil" @click="handlershowUserMenu"
        v-if="userInfo?.user_name && !isIframeEmbedded">
        <div class="sidebar-item_text" @mouseenter="isUserImg = true" @mouseleave="isUserImg = false">
          <img class="sidebar-item_clear" :src="isUserImg
            ? require('@/assets/images/user-img-hover.png')
            : require('@/assets/images/user-img.png')" />
          <div v-if="sidebarWidth" class="user-name">{{ userInfo?.company }}</div>
        </div>
        <div v-if="showUserMenu" class="user-menu">
          <div class="menu-grid">
            <!-- 第一行 -->
            <!-- 用户信息 -->
            <div class="menu-item" @click="showDialog">
              <div class="menu-icon">
                <img src="../assets/images/avatar_user.png" alt="账户信息" />
              </div>
              <div class="menu-text">{{ $t('bar.userinfo') }}</div>
            </div>
            <!-- 激活码 -->
            <div class="menu-item" @click="showCodeDialog">
              <div class="menu-icon">
                <img src="../assets/images/avatar_authcode.png" alt="授权码" />
              </div>
              <div class="menu-text">{{ $t('bar.activation') }}</div>
            </div>

            <!-- 我的订单 -->
            <div class="menu-item" @click="showOrderDialog">
              <div class="menu-icon">
                <img src="../assets/images/avatar_order.png" alt="我的订单" />
              </div>
              <div class="menu-text">{{ $t('bar.myOrder') }}</div>
            </div>

            <!-- 我的知识库 -->
            <div class="menu-item" @click="showKnowledgeDialog">
              <div class="menu-icon">
                <img src="../assets/images/avatar_knowledge.png" alt="知识库" />
              </div>
              <div class="menu-text">{{ $t('bar.myKnowledgeBase') }}</div>
            </div>

            <!-- 第二行 -->
            <!-- 我的方案 -->
            <div class="menu-item" @click="showPlanDialog">
              <div class="menu-icon">
                <img src="../assets/images/avatar_plan.png" alt="方案" />
              </div>
              <div class="menu-text">{{ $t('bar.myProposal') }}</div>
            </div>

            <!-- 我的服务 -->
            <div class="menu-item" @click="showServiceDialog">
              <div class="menu-icon">
                <img src="../assets/images/avatar_service.png" alt="我的服务" />
              </div>
              <div class="menu-text">{{ $t('bar.myService') }}</div>
            </div>
            <!-- 切换语言    已完成版本放开可直接使用 -->
            <!-- <div class="menu-item" @mouseenter.stop="showLanguage" @mouseleave.stop="showLanguage">
              <div>
                <div class="menu-icon">
                  <img src="../assets/images/avatar_language.png" alt="切换语言" />
                </div>
                <div class="menu-text">{{ $t('switchLang') }}</div>
                <Language v-if="showSetLanguage" :languages="supportedLanguages" :current-language="currentLanguage"
                  @language-changed="handleLanguageChange">
                </Language>
              </div>
            </div> -->

            <!-- 帮助中心 -->
            <div class="menu-item" @click="goManual">
              <div class="menu-icon">
                <img src="../assets/images/avatar_manual.png" alt="帮助中心" />
              </div>
              <div class="menu-text">{{ $t('bar.manual') }}</div>
            </div>
            <!-- 退出登录 -->
            <div class="menu-item logout-item" @click="logout">
              <div class="menu-icon">
                <img src="../assets/images/avatar_logout.png" alt="退出登录" />
              </div>
              <div class="menu-text">{{ $t('bar.logout') }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 未登录的头像 -->
      <div v-else-if="!isIframeEmbedded" class="sidebar-item_new sidebar-specil" @click.stop="toggleLogin">
        <div class="sidebar-item_text" @mouseenter="isUserImg = true" @mouseleave="isUserImg = false">
          <img class="sidebar-item_clear" :src="isUserImg
            ? require('@/assets/images/user-img-hover.png')
            : require('@/assets/images/user-img.png')" />
        </div>
      </div>
    </div>
    <AuthCodeListDialog ref="authCodeListDialog" @activated="handleActivated" />
    <ChooseProduct ref="chooseProduct" />
    <OrderDialog ref="orderDialog" />
    <KnowledgeDialog ref="knowledgeDialog" />
    <PlanDialog ref="planDialog" @open-plan-conversation="handleOpenConversationFromPlan" />
    <!-- 提示 -->
    <el-dialog :title="$t('orderI18n.tips')" :visible.sync="tipsVisible" width="380px" :modal-append-to-body="false"
      :close-on-click-modal="false" custom-class="custom-delete-dialog" :before-close="() => (tipsVisible = false)"
      center top="30vh">
      <div class="dialog-content">
        <div class="dialog-text">{{ $t('bar.buyService') }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tipsVisible = false" class="custom-cancel-btn">
          {{ $t('orderI18n.cancelBtn') }}
        </el-button>
        <el-button type="primary" @click="confirm" class="custom-delete-btn">
          {{ $t('orderI18n.buy') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import { handleLogout } from '@/utils/request';
import { logoutApi, getAccount, getFeatures, updateAccount, customconfigs } from "@/api";
import ChooseProduct from './ChooseProduct';
import OrderDialog from './OrderDialog';
import KnowledgeDialog from './KnowledgeDialog'; // 知识库
import PlanDialog from './PlanDialog'; // 方案
import AuthCodeListDialog from './AuthCodeListDialog';
import dayjs from 'dayjs';
import Language from '@/components/Language.vue';
import chatList from "@/components/chatList.vue";

export default {
  components: {
    ChooseProduct,
    OrderDialog,
    AuthCodeListDialog,
    KnowledgeDialog,
    PlanDialog,
    Language,
    chatList
  },
  data() {
    return {
      showUserMenu: false,
      showHistory: false,
      showSetLanguage: false,
      siderBarList: [],
      activeClass: null,
      tipsVisible: false,
      pendingToChat: null, // 记录未登录时的 toChat 参数
      currentLanguage: {
        code: 'zh-CN',
        name: '简体中文',
        icon: '🇨🇳'
      },
      // 支持的语言列表
      supportedLanguages: [
        { code: 'zh-CN', name: '简体中文', icon: '中' },
        { code: 'en', name: 'English', icon: 'EN' }
      ],
      isProcessingLogin: false,
      sidebarWidth: false,
      isHoveringNewChat: false,
      NewChat_clear: false,
      showAiHistory: null,
      showCarbonHistory: null,
      isUserImg: false,
      showhistoryhr: true
    };
  },
  computed: {
    ...mapState(['userInfo', 'accessType', 'isResponding', 'referer', 'showLogin', 'permission']),
    isWecomePage() {
      return this.$route.name === 'WecomePage';
    },
    // 判断是否通过iframe嵌入
    isIframeEmbedded() {
      const iframeUrl = ['https://carbcare.cn', 'https://www.carbcare.cn'];
      if (this.referer && iframeUrl.includes(this.referer)) {
        return this.referer;
      } else {
        return false;
      }
    },


  },
  created() {
    if (this.permission == true) {
      this.sidebarWidth = true
      // this.tipsVisible = true;
      // this.setPermission(null)
      this.changeWidth()
    }
  },
  methods: {
    ...mapMutations(['setUserInfo', 'setToken', 'setShowLogin', , 'setPermission', 'setAccessType', 'setCustomUiConfig', 'setSidebarExpanded', 'setReadonly']),

    // 获取图标
    handlerImg(code) {
      if (code == 'tpc') {
        return require('@/assets/images/chat_tpc.png')
      } else if (code == 'tzj') {
        return require('@/assets/images/chat_tzj.png')
      } else {
        return require('@/assets/images/chat_esg.png')
      }
    },

    handlerhistoryhr() {
      this.showhistoryhr = !this.showhistoryhr;
      this.$nextTick(() => {
        // 每次展开 AI 历史时，滚动到顶部
        if (this.showhistoryhr) {
          this.scrollToTop();
        }
      });
    },

    // 获取侧边栏图标组件
    async fetchSidebarList() {
  try {
    const res = await getFeatures();
    if (res.data && Array.isArray(res.data.data)) {
      const list = res.data.data
        // 过滤掉 code 为 'eco' 的项
        .filter(item => item.code !== 'eco') 
        .map(item => ({
          ...item,
        }));
        
      this.siderBarList = list;
    }
  } catch (e) {
    this.$message.error(this.$t('bar.getFeatureFailed'));
  }
},

    // 检查 ChatPage 的 isResponding 状态
    async checkIsResponding() {
      if (this.isResponding) {
        this.$message.warning(this.$t('chatPage.being'));
        return true;
      }
      return false;
    },

    //校验过期
    getAccountTime() {
      return dayjs(this.userInfo?.vip_end_time).isBefore(dayjs(), 'day');
    },

    // 显示语言选择器
    showLanguage() {
      this.showSetLanguage = !this.showSetLanguage; // 显示语言选择器
    },

    // 点击用户头像显示或隐藏用户菜单
    async toggleLogin() {
      if (await this.checkIsResponding()) return; // 检查是否正在响应
      this.setShowLogin(true); // 显示登录框
      this.setAccessType('tz');
    },

    // 退出登录
    async logout() {
      if (await this.checkIsResponding()) return; // 检查是否正在响应
      logoutApi().then((res) => {
        if (res.data.code === 200) {
          this.activeClass = null
          handleLogout(); // 调用公共方法
          // this.$message.success(this.$t('accountI18n.logoutSuccess'));
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(() => {
        this.activeClass = null
        this.$message.error(this.$t('accountI18n.logoutError'));
        // this.setShowLogin(true); // 显示登录框
      });
    },

    // 点击其他地方关闭用户菜单
    closeUserMenu() {
      this.showUserMenu = false;
    },

    // 切换侧边栏宽度
    changeWidth() {
      this.showUserMenu = false;
      this.sidebarWidth = !this.sidebarWidth;
      this.setSidebarExpanded(true); // 更新Vuex状态
    },

    // 点击返回首页
    async goHome() {
      if (await this.checkIsResponding()) return; // 检查是否正在响应
      if (this.$route.name !== 'WecomePage') { // 检查当前路由是否为 WecomePage
        this.$router.push({ name: 'WecomePage' });
      }
      // this.setAccessType('');
      this.activeClass = null;
    },

    // 添加一个方法来监听sidebar宽度变化
    handleSidebarResize() {
      const sidebarElement = this.$el.querySelector('.sidebar');
      if (sidebarElement) {
        const isExpanded = sidebarElement.classList.contains('sidebar-expanded');
        this.setSidebarExpanded(isExpanded);
      }
    },

    handlershowUserMenu() {
      this.showUserMenu = !this.showUserMenu;
    },

    // 监听点击事件，判断是否点击在侧边栏之外
    handleOutsideClick(event) {
      const sidebar = this.$el;
      if (!sidebar.contains(event.target)) {
        this.closeUserMenu(); //
      }

      // 获取触发按钮和菜单 DOM
      const menu = this.$el.querySelector('.user-menu');
      const trigger = this.$el.querySelector('.sidebar-specil'); // 用户头像区域

      // 如果菜单未显示，无需处理
      if (!this.showUserMenu) return;

      // 如果点击的是菜单本身或其内部，或者点击的是触发按钮，则不关闭
      if (
        menu?.contains(event.target) ||
        trigger?.contains(event.target)
      ) {
        return;
      }

      // 否则关闭菜单
      this.showUserMenu = false;
    },

    // 点击新对话
    async newChat() {
      this.setReadonly(false);
      if (await this.checkIsResponding()) return; // 检查是否正在响应
      // this.$emit('close-chat-list');  关闭历史记录列表
      if (this.isWecomePage) return;
      this.setAccessType('tz');
      this.$emit('start-new-chat'); // 触发父组件事件
    },

    handlerhistoryhr() {
      this.showhistoryhr = !this.showhistoryhr
    },

    scrollToTop() {
      const scroller = this.$refs.sidebarHistoryScroller;
      if (scroller) {
        scroller.scrollTo({
          top: 0,
          behavior: 'smooth' // 平滑滚动
        });
      }
    },

    handleReferenceClick(event) {
      // 如果是欢迎页，禁止操作
      if (this.isWecomePage) return;

      const isAddClick = event.target.closest('.item_add');
      const isSidebarExpanded = this.sidebarWidth;

      // 判断是否允许触发下拉
      const shouldTriggerDropdown =
        (!isSidebarExpanded && !isAddClick) || // 收起时：点击非+也触发
        (isSidebarExpanded && isAddClick);      // 展开时：只允许点+

      // 如果不应该触发，则阻止默认行为（即不弹出）
      if (!shouldTriggerDropdown) {
        this.showHistory = !this.showHistory
         this.$nextTick(() => {
          if (this.showHistory) {
            this.scrollToTop();
          }
        });
        event.stopPropagation();
        return;
      }

      // 如果应该触发，就让 el-dropdown 执行
      // 注意：这里需要手动触发 click，因为 el-dropdown 只监听自己的 reference
      this.$nextTick(() => {
        const dropdown = this.$refs.dropdownRef;
        if (dropdown && dropdown.$el) {
          // 模拟点击 reference
          const reference = dropdown.$el.querySelector('.dropdown-reference-wrapper');
          if (reference) {
            reference.click();
          }
        }
      });
    },

    handleCommand(command) {
      let value, title, index;
      if (command.code === 'tpc') {
        value = 'tpc';
        title = '碳盘查项目';
        index = 0;
      } else if (command.code === 'tzj') {
        value = 'tzj';
        title = '碳足迹项目';
        index = 1;
      } else {
        return;
      }
      this.toChat(value, title, index);
      this.setReadonly(false);
      if (this.sidebarWidth == false) {
        return
      } else {
        this.$refs.chatListT.loadHistory('carbon-check');
      }
    },

    //碳盘查功能
    async toChat(value, t, index) {
      if (await this.checkIsResponding()) return; // 检查是否正在响应
      this.$emit('close-chat-list'); // 关闭历史记录列表
      if (value != 'tz') {
        if (this.userInfo?.user_name) {
          // 已登录用户，正常流程
          const haveActive = await this.checkFeature(value);
          if (t && haveActive == false) {
            this.tipsVisible = true;
            return;
          }
          this.setAccessType(value);
          if (!this.isWecomePage) {
            this.$emit('start-new-chat'); // 触发父组件事件
          } else {
            this.$router.push({ name: 'ChatPage' });
          }
          this.activeClass = index;
        } else {
          // 未登录用户
          if (this.isIframeEmbedded) {
            // 通过iframe嵌入时，显示产品介绍页面
            this.showProductIntroduction(value);
          } else {
            // 直接访问时，显示登录框
            this.setAccessType(value);
            this.pendingToChat = { value, t, index };
            this.setShowLogin(true); // 显示登录框
          }
        }
      } else {
        // AI功能，无需登录
        this.setAccessType(value); // 设置 accessType 为 'tz'
        this.activeClass = index;
        if (!this.isWecomePage) {
          this.$emit('start-new-chat'); // 触发父组件事件
        } else {
          this.$router.push({ name: 'ChatPage' });
        }
      }
    },

    // 确认购买
    confirm() {
      this.tipsVisible = false; // 关闭提示框
      this.$parent.$refs.serviceDialog.showModal();
    },

    // 显示产品介绍页面
    showProductIntroduction(value) {
      // 显示ThirdSide的产品介绍对话框
      if (this.$parent.$refs.dialogManager) {
        this.$parent.$refs.dialogManager.showProductIntroduction(value);
      } else {
        // 如果没有DialogManager，则使用原来的ServiceDialog
        this.$parent.$refs.serviceDialog.showModal();

        // 根据产品类型设置介绍内容
        if (value === 'tpc') {
          // 碳盘查产品介绍
          this.$parent.$refs.serviceDialog.selectProduct = '碳盘查';
        } else if (value === 'tzj') {
          // 碳足迹产品介绍
          this.$parent.$refs.serviceDialog.selectProduct = '碳足迹';
        }
      }
    },

    // 检查用户是否有访问某个功能的权限
    async checkFeature(t) {
      let features = "";
      if (this.userInfo?.user_name) {
        try {
          const response = await getAccount({
            user_id: this.userInfo?.user_id,
          });
          const { ...userInfo } = response.data.data;
          features = userInfo?.features?.some(f => f.code === t);
          this.setUserInfo(userInfo);
          return features;
        }
        catch (error) {
          this.$message.error(this.$t('accountI18n.getUserInfoError'));
        }
      }
    },

    //显示个人信息弹窗
    showDialog() {
      this.$emit('show-user-dialog', true); // 通知父组件显示用户信息弹窗
    },

    // 切换语言
    async handleLanguageChange(lang) {
      if (this.$i18n.locale === lang.code) return; // 如果当前语言已经是选中的语言，则不做任何操作
      if (await this.checkIsResponding()) return; // 检查是否正在响应
      this.currentLanguage = lang;
      updateAccount({
        configuration: {
          language: lang.code
        }
      }).then((res) => {
        if (res.data.code == 200) {
          this.$i18n.locale = lang.code;
          //触发语言变更全局事件
          this.$root.$emit('languageChanged');

          const currentUrl = window.location.href;
          const urlId = this.getQueryParam(currentUrl, 'id');
          if (this.$route.name == "ChatPage") {
            this.$router
              .push({
                name: "ChatPage",
                query: {
                  id: urlId
                }
              })
              .catch((err) => {
                if (err.name !== "NavigationDuplicated") {
                  console.error(err);
                }
              });
          }
        }
      }).catch(() => { });
    },

    //截取url参数
    getQueryParam(url, param) {
      const regex = new RegExp(`[?&]${param}=([^&]+)`);
      const match = url.match(regex);
      return match ? decodeURIComponent(match[1]) : null;
    },

    //显示授权码激活弹窗
    showCodeDialog() {
      this.$refs.authCodeListDialog.showModal();
    },

    //显示服务信息弹窗
    showServiceDialog() {
      // this.$emit('show-service-dialog', true); // 通知父组件显示用户信息弹窗
      // this.$refs.serviceDialog.showModal();
      this.$parent.$refs.serviceDialog.showModal();
    },

    //显示订单信息弹窗
    showOrderDialog() {
      this.$refs.orderDialog.showModal();
    },

    // 知识库
    showKnowledgeDialog() {
      this.$refs.knowledgeDialog.showModal();
    },

    // 我的方案
    showPlanDialog() {
      this.$refs.planDialog.showModal();
    },

    // 从「我的方案」打开碳知（tz）会话详情：同步 accessType、跳转 ChatPage、侧栏列表锁定该会话
    handleOpenConversationFromPlan({ conversationId, accessType }) {
      if (!conversationId) {
        this.$message.warning(this.$t('myPlanI18n.noConversationId'));
        return;
      }
      const id = String(conversationId);
      const type = accessType || 'tz';
      this.setAccessType(type);
      this.setReadonly(false);
      this.$refs.planDialog?.hideModal?.();

      const runFocus = () => {
        this.$nextTick(() => {
          if (type === 'tz' && this.$refs.chatListAi) {
            this.$refs.chatListAi.focusConversationById(id);
          }
        });
      };

      if (this.$route.name !== 'ChatPage' || String(this.$route.query.id || '') !== id) {
        this.$router
          .push({ name: 'ChatPage', query: { id } })
          .then(runFocus)
          .catch((err) => {
            if (err && err.name === 'NavigationDuplicated') {
              runFocus();
            } else if (err) {
              console.error(err);
            }
          });
      } else {
        runFocus();
      }
    },

    //显示配置信息弹窗
    showSetDialog() {
      this.$emit('show-set-dialog', true); // 通知父组件显示用户信息弹窗
    },

    //授权码激活成功回调
    handleActivated() {
      this.loginSuccessHandler();
    },

    //初始化用户信息和语言
    async loadUserInfoAndLanguage() {
      if (this.userInfo?.user_name && this.userInfo?.user_id) {
        try {
          const response = await getAccount({
            user_id: this.userInfo.user_id,
          });
          const { ...userInfo } = response.data.data;
          // 初始化语言
          this.$i18n.locale = userInfo?.configuration?.language ? userInfo?.configuration?.language : this.$i18n.locale;
          this.setUserInfo(userInfo);
        } catch (error) {
          this.$message.error(this.$t('accountI18n.getUserInfoError'));
        }
      }
    },

    // 跳转使用手册
    goManual() {
      const { href } = this.$router.resolve({ name: 'Manual' });
      window.open(href, '_blank');
    },

    onAiHistoryEmpty() {
      this.showAiHistory = false;
    },
    onAiHistoryNotEmpty() {
      this.showAiHistory = true;
    },
    onCarbonHistoryEmpty() {
      this.showCarbonHistory = false;
    },
    onCarbonHistoryNotEmpty() {
      this.showCarbonHistory = true;
    },
  },
  async mounted() {
    this.$root.$on('login-success-and-check-feature', () => {
      this.tipsVisible = true;
      this.sidebarWidth = true;
      this.setPermission(null)
    });
    this.changeWidth()
    // 监听DOM变化
    const sidebarElement = this.$el.querySelector('.sidebar');
    if (sidebarElement) {
      const isExpanded = sidebarElement.classList.contains('sidebar-expanded');
      this.setSidebarExpanded(isExpanded);
    }

    // 监听DOM变化
    const observer = new MutationObserver(this.handleSidebarResize);
    if (sidebarElement) {
      observer.observe(sidebarElement, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    // 监听历史记录刷新事件
    this.$root.$on('refresh-chat-history', ({ type }) => {
      if (!this.sidebarWidth) return; // 如果侧边栏未展开，可不刷新（按需）

      if (type === 'tz') {
        this.$refs.chatListAi?.loadHistory?.('tz'); // 注意 ref 名要唯一
      } else if (type === 'tpc' || type === 'tzj') {
        this.$refs.chatListT?.loadHistory?.('carbon-check');
        this.showHistory = true
      }
    })

    // 保存observer以便在组件销毁时清理
    this.sidebarObserver = observer;
    // 刷新页面和登陆成功后初始化用户信息和语言
    this.loadUserInfoAndLanguage();
    // 监听点击事件
    document.addEventListener('click', this.handleOutsideClick);

    if (this.showLogin) {
      this.$emit('show-set-dialog', false)
    }

    this.$root.$on('setSidebarActive', (code) => {
      const idx = this.siderBarList.findIndex(item => item.code === code);
      if (idx !== -1) {
        this.activeClass = idx;
      }
    });

    this.loginSuccessHandler = async () => {
      if (this.isProcessingLogin) return;
      this.isProcessingLogin = true;
      try {
        await this.fetchSidebarList();
        await this.loadUserInfoAndLanguage();
      } finally {
        this.isProcessingLogin = false;
      }
    };
    this.$root.$on('loginSuccess', this.loginSuccessHandler);
    await this.fetchSidebarList();

    if (this.accessType) {
      const idx = this.siderBarList.findIndex(item => item.code === this.accessType);
      if (idx !== -1) {
        this.activeClass = idx;
      }
    }

    this.currentLanguage = this.supportedLanguages.find(lang => lang.code === this.$i18n.locale);
  },

  beforeDestroy() {
    // 移除监听
    this.$root.$off('refresh-chat-history');
    this.$root.$off('login-success-and-check-feature');
    // 移除点击事件监听
    document.removeEventListener('click', this.handleOutsideClick);
    // 移除登录成功事件监听
    this.$root.$off('loginSuccess', this.loginSuccessHandler);
    if (this.sidebarObserver) {
      this.sidebarObserver.disconnect();
    }
  },

  watch: {
    // 监听语言变化并更新AI助手标题
    '$i18n.locale'() {
      const aiItemIndex = this.siderBarList.findIndex(item => item.code === 'tz');
      if (aiItemIndex !== -1) {
        this.siderBarList[aiItemIndex].title = this.$t('bar.aiAssistant');
      }
    },
  }
};
</script>

<style scoped>
.sidebar {
  width: 92px;
  height: calc(100vh);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  cursor: url('../assets/images/rightJ.svg') 8 8, auto;
  padding-top: 41px;
}

.sidebar.sidebar-expanded {
  width: 357px;
  align-items: flex-start;
  padding: 40px 20px 10px 25px;
  cursor: default;
}

/* logo样式 */
.sidebar-item_img {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 50px;
}

.sidebar-expanded .sidebar-item_img {
  width: 100%;
  box-sizing: border-box;
  justify-content: flex-start;
}

.sidebar_logo {
  width: 42px !important;
  height: 42px !important;
  cursor: pointer;
}

.sidebar-logo {
  width: 42px !important;
  height: 42px !important;
}

.sidebar-fold {
  width: 24px !important;
  height: 24px !important;
  cursor: pointer;
}

.sidebar-expanded .sidebar-item_img .sidebar-fold {
  margin-left: auto;
  /* 自动推到最右边 */
}

.homeFontCn {
  font-size: 30px;
  font-weight: 700;
  color: #000;
  text-align: center;
  margin-left: 8px;
}

/* 新对话，新项目 */
.sidebar-item_new {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  height: 60px;
  width: 52px;
  margin: 0 auto;
}

.sidebar-item_new.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.sidebar-expanded .el-dropdown {
  width: 100%;
}

.sidebar-expanded .sidebar-item_new {
  width: 100%;
  height: 40px;
  padding-left: 2px;
  line-height: 40px;
  align-items: center;
  flex-direction: row;
}

.mg-top {
  margin-bottom: 50px;
}

.sidebar-expanded .mg-top {
  margin-bottom: 37px;
}

.mg-new {
  margin-bottom: 0;
}

.sidebar-expanded .mg-bottom {
  margin-top: 24px;
}

.no-rem {
  margin-top: 5px;
  font-size: 14px !important;
  font-weight: 700 !important;
  line-height: 1;
  color: rgba(88, 110, 109, 1);
  -webkit-text-size-adjust: 100%;
  /* 关键！防止 iOS 自动放大 */
  text-size-adjust: 100%;
}

.sidebar-expanded .sidebar-item_new .item_left {
  margin: 0;
}

.sidebar-expanded .sidebar-item_new .no-rem {
  margin: 0 0 0 6px !important;
  white-space: nowrap;
  text-align: left;
  
}

.sidebar-expanded .sidebar-item_new .no-left {
  margin: 0 0 0 4px !important;
  white-space: nowrap;
  text-align: left;
  display: flex;
  align-items: center;
  color: rgba(170, 179, 187, 1);
  /* justify-content: space-between; */

}

.sidebar-expanded .item_fold {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sidebar-expanded .item_fold:hover {
  background-color: rgba(209, 219, 242, 1);
  border-radius: 8px;
  color: rgba(170, 179, 187, 1);
}

.item_harvest {
  width: 20px;
  height: 20px;
  margin-left: 5px;
  margin-top: 3px;
}

.item_add {
  width: 38px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  margin-right: 1px;
}

.item_add:hover {
  background-color: rgba(182, 195, 224, 1);
  border-radius: 6px;
}

.item_add_img {
  width: 18px;
  height: 18px;
}

.mg-top:hover .no-rem {
  color: rgba(24, 161, 246, 1) !important;
}

.mg-new:hover .no-rem {
  color: rgba(24, 161, 246, 1) !important;
}

.sidebar-expanded .mg-new:hover .no-rem {
  /* color: rgba(88, 110, 109, 1) !important; */
  color: rgba(170, 179, 187, 1) !important;
}

.sidebar-item_clear {
  width: 32px;
  height: 32px;
}

/* 历史记录 */
.sidebar_history_item {
  width: 100%;
  font-size: 18px;
  font-weight: 700;
  color: rgba(176, 192, 191, 1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 4px;
}

.sidebar_hr {
  width: 100%;
  margin: 16px 0;
  height: 1px;
  background-color: rgba(225, 233, 232, 1);
  box-sizing: border-box;
}

.sidebar_history {
  max-height: calc(100vh - 310px);
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;

  &::-webkit-scrollbar {
    display: none;
  }
}

.sidebar_hrje {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: rgba(239, 248, 254, 1);
  /* opacity: 0.8; */
}

.history-separator {
  height: 30px;
}

.sidebar_history_hr {
  height: 40px;
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  color: rgba(170, 179, 187, 1);
  padding-left: 4px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}


.sidebar_history_hr:hover {
  background-color: rgba(209, 219, 242, 1);
  border-radius: 8px;

}

/* 新项目 */
.dropdown_newProject {
  border: none !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
  padding: 8px !important;
  min-width: 144px !important;
  background: white !important;
  overflow: hidden !important;
}

.dropdown_newProject_item {
  display: flex;
  align-items: center;
  padding: 0 6px 0 6px !important;
  margin-top: 1px;
}

.dropdown_newProject_item:hover {
  background: rgba(219, 232, 245, 1) !important;
  border-radius: 6px !important;
}

.dropdown_newProject_item_img {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

.dropdown_newProject_item_div {
  font-size: 14px;
  font-weight: 700;
  color: rgba(0, 43, 37, 1);
}

.custom-divider {
  height: 1px;
  background-color: #ebeef5;
  margin: 2px 0;
  display: block;
}

/* 用户头像 二级菜单 */
.sidebar-specil {
  width: 100%;
  height: 56px;
  position: absolute;
  bottom: 10px;
  right: 0;
  padding-top: 20px;
}

.sidebar-expanded .sidebar-specil {
  width: 100%;
  height: 56px;
  position: absolute;
  bottom: 10px;
  right: 0;
  left: 8px;
  padding-top: 15px;
  margin-top: 8px;
}

.sidebar-item_text {
  display: flex;
  align-items: center;
}

.sidebar-expanded .sidebar-item_text {
  padding-left: 20px;
  width: 100%;
  box-sizing: border-box;
  justify-content: flex-start;
  align-items: center;
}

.sidebar-item_puhui {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

/* .sidebar-item_puhui:hover {
  border: 1px solid rgba(24, 161, 246, 1);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  box-sizing: border-box;
} */

.sidebar-expanded .sidebar-item_text .sidebar-item_puhui {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 16px;
}

/* .sidebar-expanded .sidebar-item_text .sidebar-item_puhui:hover {
  border: 1px solid rgba(24, 161, 246, 1);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  box-sizing: border-box;
  margin-right: 16px;
} */

.user-name {
  font-size: 16px;
  font-weight: 700;
  color: rgba(170, 179, 187, 1);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 20px;
}

.user-menu {
  position: absolute;
  bottom: 50px;
  left: 20px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  padding: 16px;
  z-index: 1000;
  width: 310px;
  height: 335px;
  transform-origin: bottom left;
  animation: expand 0.6s ease-out forwards;
  cursor: default;
  box-sizing: border-box;
}

.menu-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 25px 5px;
  width: 100%;
}

.menu-item {
  width: 89px;
  height: 84px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  padding: 4px 0;
  cursor: pointer;
  transition: all 0.2s ease;
  background: transparent;
  border: 1px solid transparent;
  position: relative;
}

.menu-item:hover {
  background: rgba(219, 232, 245, 1);
  box-shadow: 0px 3px 4.9px 0px rgba(0, 0, 0, 0.25);
}

.menu-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
}

.menu-icon img {
  width: 32px;
  height: 32px;
}

.menu-text {
  font-size: 14px;
  color: #000000;
  text-align: center;
  font-weight: 700;
}

.logout-item:hover {
  background: #ffebee;
}

.logout-item .menu-icon,
.logout-item .menu-text {
  color: rgba(248, 177, 177, 1);
}

/* 二级菜单打开样式设置 */
@keyframes expand {
  0% {
    transform: scale(0);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>

<style>
.el-tooltip__popper.is-dark {
  font-size: 14px !important;
}

.el-tooltip__popper.is-dark[x-placement^=bottom] .popper__arrow::after {
  border-bottom-color: transparent !important;
}

.el-tooltip__popper.is-dark[x-placement^=bottom] .popper__arrow {
  border-bottom-color: transparent !important;
}
</style>
